import React from "react";
import { dashboardIcon } from "../../assets/img";

function Location({ isDataAllCard }) {
  const styles = {
    label: {
      fontFamily: "Open Sans",
      fontStyle: "normal",
      fontWeight: "600",
      fontSize: "14px", // smaller
      lineHeight: "20px",
      color: "#A7A7A7",
    },
    value: {
      fontFamily: "Open Sans",
      fontStyle: "normal",
      fontWeight: "600",
      fontSize: "16px", // smaller
      lineHeight: "22px",
      color: "#222227",
    },
  };

  return (
    <div
      style={{
        padding: 14, // smaller
        width: "100%",
        background: "#FFFFFF",
        boxShadow: "0px 1px 8px rgba(0, 0, 0, 0.1)", // lighter
        borderRadius: "8px", // smaller
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 12, // smaller
        }}
      >
        <p
          style={{
            fontStyle: "normal",
            fontWeight: "700",
            fontSize: "15px", // smaller
            lineHeight: "20px",
            display: "flex",
            alignItems: "center",
            color: "#222227",
            margin: 0,
          }}
        >
          Location
        </p>
      </div>

      {/* Total States & Cities */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "12px", // smaller
        }}
      >
        {[
          {
            label: "Total States",
            value: isDataAllCard?.location?.total_states,
          },
          {
            label: "Total Cities",
            value: isDataAllCard?.location?.total_cities,
          },
        ].map((item, index) => (
          <div
            key={index}
            style={{
              border: "1px solid #EEEEEE",
              display: "flex",
              justifyContent: "space-between",
              borderRadius: "16px", // smaller
              padding: "10px 16px", // smaller
              width: "48%",
            }}
          >
            <div>
              <p
                style={{
                  fontSize: "16px", // smaller
                  fontWeight: "400",
                  color: "#9ca3af",
                  margin: 0,
                  display: "flex",
                  alignItems: "center",
                  gap: "6px", // smaller
                }}
              >
                {item.label}
              </p>
              <p
                style={{
                  fontSize: "22px", // smaller
                  fontWeight: "bold",
                  color: "#000000",
                  margin: 0,
                }}
              >
                {(item.value || 0).toFixed(2)}
              </p>
            </div>
            <div style={{ width: "26px", height: "26px" }}>
              <img
                src={dashboardIcon}
                alt=""
                style={{ width: "100%", height: "100%" }}
              />
            </div>
          </div>
        ))}
      </div>

      {/* Total Locations */}
      <p
        style={{
          marginTop: "8px",
          fontFamily: "Open Sans",
          fontStyle: "normal",
          fontWeight: "700",
          fontSize: "15px", // smaller
          lineHeight: "20px",
          color: "#222227",
        }}
      >
        Total
      </p>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 4, // smaller
          marginTop: "8px",
        }}
      >
        <div
          style={{
            background: "#F5F5F5",
            display: "flex",
            justifyContent: "space-between",
            padding: "8px 10px", // smaller
            width: "100%",
            borderRadius: "8px", // smaller
            marginBottom: "8px", // smaller
          }}
        >
          <p style={styles.label}>Locations</p>
          <p style={styles.value}>
            {(isDataAllCard?.location?.locations || 0).toFixed(2)}
          </p>
        </div>
      </div>
    </div>
  );
}

export default Location;
